var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 447.994V241.34C512 206.09 473.641 177.334 426.621 177.334H371.351C362.002 177.334 354.44 183.003 354.44 190.011C354.44 197.02 356.365 209.505 365.714 209.505H429.714C458.174 209.505 475.429 228.503 475.429 249.838L475.429 448.2C475.429 469.535 455.081 486.954 426.621 486.954H85.3792C56.9194 486.954 36.5714 472.836 36.5714 451.501V239.755C36.5714 218.419 56.9194 209.505 85.3792 209.505H146.286C155.635 209.505 157.56 196.917 157.56 189.908C157.56 182.9 149.998 177.231 140.649 177.231H85.3792C38.3587 177.231 0 205.987 0 241.237V447.994C0 483.244 38.3587 512 85.3792 512H426.621C473.779 512 512 483.347 512 447.994Z",
    fill: "#0189CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.028 121.874C126.136 127.47 137.538 127.47 144.645 121.874L237.934 48.4349V316.313C237.934 324.24 246.079 330.652 256.148 330.652C266.217 330.652 274.361 324.24 274.361 316.313V48.5515L367.65 121.991C371.204 124.788 375.795 126.187 380.533 126.187C385.272 126.187 389.862 124.788 393.416 121.991C400.524 116.395 400.524 107.42 393.416 101.824L269.179 4.02167C262.367 -1.34056 250.373 -1.34056 243.561 4.02167L119.324 101.824C111.92 107.303 111.92 116.279 119.028 121.874Z",
    fill: "#0189CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.fc6d9b6353c437aafc086a124bc10bc7.svg";
export { ForwardRef as ReactComponent };